import React from "react";
import { Lock, Loader2 } from "lucide-react";

export default function AdminSignIn({ authTry, setAuthTry, onSubmit, loading }) {
  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="admin-signin">
      <div className="border border-zinc-900 bg-white">
        <div className="bg-zinc-900 text-white px-6 py-5 flex items-center gap-3 border-b border-red-600">
          <Lock size={18} />
          <div>
            <div className="label-eyebrow text-red-500">Restricted</div>
            <div className="font-display font-black text-2xl">Admin Access</div>
          </div>
        </div>
        <form onSubmit={onSubmit} className="p-6 space-y-4">
          <div>
            <label className="label-eyebrow block mb-2">Admin Token</label>
            <input
              type="password"
              value={authTry}
              onChange={(e) => setAuthTry(e.target.value)}
              className="field font-mono"
              placeholder="Enter admin token..."
              data-testid="admin-token-input"
              autoFocus
            />
            <p className="text-xs text-zinc-500 mt-2">
              Configured via <code className="font-mono">ADMIN_TOKEN</code> env var on
              the backend. Session-scoped — closing this tab signs you out.
            </p>
          </div>
          <button
            type="submit"
            disabled={loading || !authTry}
            className="btn-primary w-full justify-center disabled:opacity-60"
            data-testid="admin-signin-submit"
          >
            {loading ? <Loader2 size={14} className="animate-spin" /> : <Lock size={14} />}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
